/**
 *  月の日数を取得
 */
export const getLastDay = (year: number, month: number): number => {
  return new Date(year, month, 0).getDate();
};
